import state from './state';

export interface Config {
  homeUrl: string;
  authorityUrl: string;
  env: string;
  bksUrl: string;
  portalUrl: string;
  featureToggleRemoveBounce: boolean;
  featureToggleTesting: boolean;
  featureToggleChangeUserNewPortal: boolean;
  defaultPollingInterval: number;
}

const getConfig = async (): Promise<Config> => {
  if (state && state.config) {
    return state.config;
  }
  const response = await fetch('/server/api/env');
  const body = await response.json();
  if (response.status !== 200) {
    throw Error(body.message);
  }
  state.config = body;
  return body;
};

export default getConfig;
